// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-tournament__search{
    width: 100%;
    margin: var(--space-x2) 24px;
    display: flex;
    align-items: flex-end;
}

.league-tournament__search-form__form {
    display: flex;
    align-items: center;
}

.league-tournament__search-form__form input:focus {
    outline: none;
}

.league-tournament__search-form__form span.icon-search {
    position: absolute;
    font-size: calc( var( --space ) + var( --space-quarter ) );
    color: #949F9A;
    margin-left: calc( var( --space ) - var( --space-eighth ) );   
}

.league-tournament__search-form__form svg { 
    position: absolute; 
} 

.league-tournament__search-form__form button {
    float: left;
    width: 20%;    
    background: var(--white-color);
    color: var(--primary-very-dark-color);    
    border: none;    
    box-shadow: none;
    cursor: pointer;
}

.league-tournament__search-form__form button:hover {
    background: var(--white-color);
    box-shadow: none;
}

.league-tournament__search_input {
    min-width: calc(var(--space-x3) * 8);
    border: 1px solid var( --new-gray-background-color);
    min-height: var( --space-x3 );
    border-radius: 4px;
    background: var( --new-background-color );
    padding-left: var( --space-x3 );    
}

.tab-panel_tournamentList_card {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: var(--space-x2);
}

.tab-panel_tournamentList_card:hover{
    background-color:rgba(177, 177, 177, 0.25);
    cursor: pointer;
    border-radius:4px;
}

.tab-panel_tournamentList_card_text{
    margin-left: var(--space-half);
}

.tab-panel_tournamentList_card_text .baloa-names{
    color: var(--primary-dark-color);
    margin-bottom: var(--space-quarter);
}

.tab-panel_tournamentList_card_inf{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
}

.tab-panel_tournamentList_card_subText{
    display: flex;
    align-items: baseline;
}

.tab-panel_tournamentList_card_subText.baloa-username p{
    color: var(--primary-dark-color);
    margin-right: var(--space);
}

.tab-panel_tournamentList_card_tags div {
    background: var( --primary-dark-color );
    color: var( --white-color );
    border-radius: var( --space-and-half );
    padding: var( --space-quarter ) var( --space-half );
}

.tab-panel_tournamentList_card_tags.baloa-username{
    color: var( --primary-dark-color);
    font-size: 11px;
}

.tab-panel_tournamentList_card_tags  {
    display: flex;
}

.tab-panel_tournamentList_card_tags .tag-active{
    background: var(--new-green-color);
}

.tab-panel_tournamentList_card_tags div:first-of-type {
    margin-right: var( --space-quarter );
}

.tab-panel_tournamentList_card_tags div:last-of-type {
    margin-left: var( --space-quarter );
}

.tab-panel_tournamentList_img{
    width: var(--space-x2-and-half);
    height: var(--space-x2-and-half);
    float: left;
    margin-top: var(--space-quarter);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half);
    border-radius: 50%;

}

.tab-panel_tournamentList_card .icon-ball {
    color: var( --white-color );
    font-size: var( --space-x2 );
    border-radius: 50%;
    padding: var( --space-quarter );  
}

.filter-button.small {
    color: var(--primary-dark-color);
    border: 0.5px solid var(--new-gray-color);
    box-sizing: border-box;
    border-radius: 5px;
    display: grid;
    justify-content: center;
    margin-left: 24px;
    padding: 14px 24px;
}

.filter-button img {
    margin-right: var(--space-half);
}
/* Pagination Component*/
.pagination_list_options{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.pagination_list_options_action{
    display: grid;
    padding: var(--space-quarter);
    width: var(--space-x2);
    height: var(--space-x2);
    border: 0.928571px solid #E7E7E7;
    box-sizing: border-box;
    border-radius: 2px;
    margin: var(--space-quarter);
    justify-items: center;
    justify-content: center;
    align-items: center;
}

.pagination_list_options_action:hover {
    cursor: pointer;
}

.pagination_list_options_action.active{
    background-color: var(--new-green-color);
    color: var(--white-color);
    font-weight: normal;
}

.tab-panel_tournamentList_card_noFound {
    display: grid;
    justify-items: center;
    align-items: center;
    padding: var(--space-x2);
}

.league-tournament-list__grid{
    display: grid;
    gap: 44px;
    /* gap: 16px; */
    grid-template-columns: repeat(3, 1fr);
    margin: 0 24px;
    /* margin: 0; */
}

.match-detail-modal__container .league-tournament-list__grid{
    height: 420px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tab-panel_tournamentList_card{
        margin: var(--space-half) 0;
    }

    .tab-panel_tournamentList_card_inf {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .tab-panel_tournamentList_card_tags.baloa-username {
        margin: 10px 0;
    }

    .league-tournament__search_input{
        width: 100%;
        border-radius: 38px;
        min-width: auto;
    }

    .tab-panel_tournamentList_card_subText.baloa-username p{
        font-size: var(--space);
    }

    .tab-panel_tournamentList_card_text .baloa-names{
        font-size: calc( var(--space) + var(--space-quarter) );
    }

    .league-tournament-list__grid{
        display: flex;
        flex-direction: column;
        margin: 0 8px 12px 8px;
        gap: 12px;
    }

    .league-tournament-list__grid.scroll{
        height: 40vh;
    }

    .league-tournament__search{
        margin: 12px;
    }

    .filter-button.small{
        margin-left: 12px;
        padding: 8px 10px;
        /* width: 30%; */
    }

    .league-tournament__search-form__form{
        width: 70%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-general-list/LeagueTournamentGeneralListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,4BAA4B;IAC5B,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,0DAA0D;IAC1D,cAAc;IACd,2DAA2D;AAC/D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,8BAA8B;IAC9B,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,mDAAmD;IACnD,6BAA6B;IAC7B,kBAAkB;IAClB,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;IAC3B,sCAAsC;IACtC,mDAAmD;AACvD;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,WAAW;IACX,gCAAgC;IAChC,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;;AAEtB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;IAChC,yCAAyC;IACzC,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;AACA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,qCAAqC;IACrC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sDAAsD;IAC1D;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".league-tournament__search{\n    width: 100%;\n    margin: var(--space-x2) 24px;\n    display: flex;\n    align-items: flex-end;\n}\n\n.league-tournament__search-form__form {\n    display: flex;\n    align-items: center;\n}\n\n.league-tournament__search-form__form input:focus {\n    outline: none;\n}\n\n.league-tournament__search-form__form span.icon-search {\n    position: absolute;\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    color: #949F9A;\n    margin-left: calc( var( --space ) - var( --space-eighth ) );   \n}\n\n.league-tournament__search-form__form svg { \n    position: absolute; \n} \n\n.league-tournament__search-form__form button {\n    float: left;\n    width: 20%;    \n    background: var(--white-color);\n    color: var(--primary-very-dark-color);    \n    border: none;    \n    box-shadow: none;\n    cursor: pointer;\n}\n\n.league-tournament__search-form__form button:hover {\n    background: var(--white-color);\n    box-shadow: none;\n}\n\n.league-tournament__search_input {\n    min-width: calc(var(--space-x3) * 8);\n    border: 1px solid var( --new-gray-background-color);\n    min-height: var( --space-x3 );\n    border-radius: 4px;\n    background: var( --new-background-color );\n    padding-left: var( --space-x3 );    \n}\n\n.tab-panel_tournamentList_card {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin: var(--space-x2);\n}\n\n.tab-panel_tournamentList_card:hover{\n    background-color:rgba(177, 177, 177, 0.25);\n    cursor: pointer;\n    border-radius:4px;\n}\n\n.tab-panel_tournamentList_card_text{\n    margin-left: var(--space-half);\n}\n\n.tab-panel_tournamentList_card_text .baloa-names{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-quarter);\n}\n\n.tab-panel_tournamentList_card_inf{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.tab-panel_tournamentList_card_subText{\n    display: flex;\n    align-items: baseline;\n}\n\n.tab-panel_tournamentList_card_subText.baloa-username p{\n    color: var(--primary-dark-color);\n    margin-right: var(--space);\n}\n\n.tab-panel_tournamentList_card_tags div {\n    background: var( --primary-dark-color );\n    color: var( --white-color );\n    border-radius: var( --space-and-half );\n    padding: var( --space-quarter ) var( --space-half );\n}\n\n.tab-panel_tournamentList_card_tags.baloa-username{\n    color: var( --primary-dark-color);\n    font-size: 11px;\n}\n\n.tab-panel_tournamentList_card_tags  {\n    display: flex;\n}\n\n.tab-panel_tournamentList_card_tags .tag-active{\n    background: var(--new-green-color);\n}\n\n.tab-panel_tournamentList_card_tags div:first-of-type {\n    margin-right: var( --space-quarter );\n}\n\n.tab-panel_tournamentList_card_tags div:last-of-type {\n    margin-left: var( --space-quarter );\n}\n\n.tab-panel_tournamentList_img{\n    width: var(--space-x2-and-half);\n    height: var(--space-x2-and-half);\n    float: left;\n    margin-top: var(--space-quarter);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half);\n    border-radius: 50%;\n\n}\n\n.tab-panel_tournamentList_card .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-x2 );\n    border-radius: 50%;\n    padding: var( --space-quarter );  \n}\n\n.filter-button.small {\n    color: var(--primary-dark-color);\n    border: 0.5px solid var(--new-gray-color);\n    box-sizing: border-box;\n    border-radius: 5px;\n    display: grid;\n    justify-content: center;\n    margin-left: 24px;\n    padding: 14px 24px;\n}\n\n.filter-button img {\n    margin-right: var(--space-half);\n}\n/* Pagination Component*/\n.pagination_list_options{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.pagination_list_options_action{\n    display: grid;\n    padding: var(--space-quarter);\n    width: var(--space-x2);\n    height: var(--space-x2);\n    border: 0.928571px solid #E7E7E7;\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: var(--space-quarter);\n    justify-items: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.pagination_list_options_action:hover {\n    cursor: pointer;\n}\n\n.pagination_list_options_action.active{\n    background-color: var(--new-green-color);\n    color: var(--white-color);\n    font-weight: normal;\n}\n\n.tab-panel_tournamentList_card_noFound {\n    display: grid;\n    justify-items: center;\n    align-items: center;\n    padding: var(--space-x2);\n}\n\n.league-tournament-list__grid{\n    display: grid;\n    gap: 44px;\n    /* gap: 16px; */\n    grid-template-columns: repeat(3, 1fr);\n    margin: 0 24px;\n    /* margin: 0; */\n}\n\n.match-detail-modal__container .league-tournament-list__grid{\n    height: 420px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tab-panel_tournamentList_card{\n        margin: var(--space-half) 0;\n    }\n\n    .tab-panel_tournamentList_card_inf {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .tab-panel_tournamentList_card_tags.baloa-username {\n        margin: 10px 0;\n    }\n\n    .league-tournament__search_input{\n        width: 100%;\n        border-radius: 38px;\n        min-width: auto;\n    }\n\n    .tab-panel_tournamentList_card_subText.baloa-username p{\n        font-size: var(--space);\n    }\n\n    .tab-panel_tournamentList_card_text .baloa-names{\n        font-size: calc( var(--space) + var(--space-quarter) );\n    }\n\n    .league-tournament-list__grid{\n        display: flex;\n        flex-direction: column;\n        margin: 0 8px 12px 8px;\n        gap: 12px;\n    }\n\n    .league-tournament-list__grid.scroll{\n        height: 40vh;\n    }\n\n    .league-tournament__search{\n        margin: 12px;\n    }\n\n    .filter-button.small{\n        margin-left: 12px;\n        padding: 8px 10px;\n        /* width: 30%; */\n    }\n\n    .league-tournament__search-form__form{\n        width: 70%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
